import { render, staticRenderFns } from "./ClienteListModal.vue?vue&type=template&id=3e95e77e&scoped=true"
import script from "./ClienteListModal.vue?vue&type=script&lang=js"
export * from "./ClienteListModal.vue?vue&type=script&lang=js"
import style0 from "./ClienteListModal.vue?vue&type=style&index=0&id=3e95e77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e95e77e",
  null
  
)

export default component.exports